import { render } from "./row.vue?vue&type=template&id=22431ce5&lang=pug"
import script from "./row.vue?vue&type=script&lang=js"
export * from "./row.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__